module.exports = __webpack_public_path__ + "img/logo.9c6d07b1.png";